export default function getTreeUrl({ treeId, pedigreeType, mePersonId }) {
  const pedigreeTypePath = pedigreeType ? `/${pedigreeType}` : ''
  const mePersonIdPath = mePersonId ? `/${mePersonId}` : ''
  const treeIdPath = treeId ? `treeId=${treeId}` : ''
  return `/tree/pedigree${pedigreeTypePath}${mePersonIdPath}/?${treeIdPath}`
}
